<template>
    <label class="block text-sm font-medium" :class="textColor">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot></slot></span>
    </label>
</template>

<script>
export default {
    props: ["value"],

    computed: {
        textColor() {
            if (!this.$el) return null
            return this.$el.classList.value.includes("text-") ? "" : "text-gray-600"
        },
    },
}
// text-gray-600
</script>
